// import React from "react";
// import { Col } from "react-bootstrap";
import { Outlet, useLocation } from "react-router-dom";
import McitiLogo from "../assests/logo/physusLogo.png";

const AuthFeature = () => {
  const location = useLocation();
  const layoutPages =
    location.pathname === "/coming-soon" ||
    location.pathname === "/under-maintenance" ||
    location.pathname === "/under-construction";

  return (
    <div
      className={`bg-linear-gradiant ${
        layoutPages ? "d-flex align-items-center justify-content-center" : ""
      }`}
    >
      <div className="main-wrapper">
        <Outlet />
      </div>
    </div>
  );
};

export default AuthFeature;

{
  /* <Col
  lg="12"
  className="d-flex justify-content-center align-items-center gap-2"
> */
}
{
  /* <div>
  <span className="mb-0"> Organized by IHFC, IIT </span>
  <img
    src={McitiLogo}
    alt="Physus Logo"
    style={{
      height: "40px",
      width: "40px",       // Corrected from "weight"
      objectFit: "contain",
    }}
  />
</div> */
}
{
  /* </Col> */
}
